import { selectExperiments } from './experiments';
import { MOBWEB_PRICE_FILTER } from '../../constants/config';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentActive } from '../../utils/experiments';

export const selectIsPriceExperimentActive = (state: IApplicationState): boolean => {
  const experiments = selectExperiments(state);

  return isAbUseExperimentActive(experiments, MOBWEB_PRICE_FILTER, 'test');
};
